"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colours = _interopRequireDefault(require("../../theme/colours"));

var _default = {
  ErrorBox: {
    boxSizing: 'border-box',
    width: '100%',
    padding: '18px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '6px',
    background: _colours["default"].blush,
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.16)'
  },
  CloseButton: {
    padding: '0',
    background: 'none',
    border: 'none',
    cursor: 'pointer'
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map